// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileMainDiv {
    position: absolute;
    margin: 7% 0 0 15%;
}

.verifiedBanButtonActive {
    text-align: center;
    margin-top: 50px;
    margin-left: 100px;
    background-color: #484848;
    color: #ffffff;
}

.verifiedBanButtonInactive {
    text-align: center;
    margin-top: 50px;
    margin-left: 100px;
    background-color: #f8f8fa;
    color: #9b9b9b;
}

.overflowX {
    overflow-x: scroll;
}

.updatesParentView {
    display:flex;
    align-content:center;
    position:fixed;
    margin-top: 220px;
    left:15%;
    right:15%;
    align-items:center;
    justify-content:center;
}

.updatesParentViewIpad {
    display:flex;
    align-content:center;
    position:fixed;
    margin-top: 200px;
    left:5%;
    align-items:center;
    justify-content:center;
}

.parentView1 {
    display:flex;
    align-content:center;
    position:fixed;
    top:54%;
    left:15%;
    bottom:0;
    right:15%;
    align-items:center;
    justify-content:center;
}

.parentView1Ipad {
    display:flex;
    align-content:center;
    position:fixed;
    top:60%;
    left:5%;
    bottom:0;
    right:5%;
    align-items:center;
    justify-content:center;
    height: 250px;
}

/* Selfie verification styles */
.selfieVerificationContainer {
    position: fixed;
    top: 56%;
    right: 54px;    
    left: auto;
    z-index: 5;
}

.selfieVerificationContainerIpad {
    position: fixed;
    top: 48%;
    right: 12px;
    left: auto;
    z-index: 5;
}

@keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
}

.selfieVerificationThumbnail {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
    border: 2px solid #ec4655;
    transition: all 0.2s ease;
}

.selfieVerificationThumbnail:hover {
    border-color: #50b3c5;
    transform: scale(1.05);
}

.selfieVerificationLabel {
    font-size: 12px;
    font-family: 'Gilroy-Medium';
    color: #484848;
    margin-top: 5px;
    text-align: center;
    background: rgba(255, 255, 255, 0.9);
    padding: 2px 6px;
    border-radius: 8px;
}

.noSelfieIndicator {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ccc;
    cursor: default;
}

.noSelfieText {
    font-size: 10px;
    font-family: 'Gilroy-Medium';
    color: #999;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Verified.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,OAAO;IACP,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,OAAO;IACP,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".profileMainDiv {\n    position: absolute;\n    margin: 7% 0 0 15%;\n}\n\n.verifiedBanButtonActive {\n    text-align: center;\n    margin-top: 50px;\n    margin-left: 100px;\n    background-color: #484848;\n    color: #ffffff;\n}\n\n.verifiedBanButtonInactive {\n    text-align: center;\n    margin-top: 50px;\n    margin-left: 100px;\n    background-color: #f8f8fa;\n    color: #9b9b9b;\n}\n\n.overflowX {\n    overflow-x: scroll;\n}\n\n.updatesParentView {\n    display:flex;\n    align-content:center;\n    position:fixed;\n    margin-top: 220px;\n    left:15%;\n    right:15%;\n    align-items:center;\n    justify-content:center;\n}\n\n.updatesParentViewIpad {\n    display:flex;\n    align-content:center;\n    position:fixed;\n    margin-top: 200px;\n    left:5%;\n    align-items:center;\n    justify-content:center;\n}\n\n.parentView1 {\n    display:flex;\n    align-content:center;\n    position:fixed;\n    top:54%;\n    left:15%;\n    bottom:0;\n    right:15%;\n    align-items:center;\n    justify-content:center;\n}\n\n.parentView1Ipad {\n    display:flex;\n    align-content:center;\n    position:fixed;\n    top:60%;\n    left:5%;\n    bottom:0;\n    right:5%;\n    align-items:center;\n    justify-content:center;\n    height: 250px;\n}\n\n/* Selfie verification styles */\n.selfieVerificationContainer {\n    position: fixed;\n    top: 56%;\n    right: 54px;    \n    left: auto;\n    z-index: 5;\n}\n\n.selfieVerificationContainerIpad {\n    position: fixed;\n    top: 48%;\n    right: 12px;\n    left: auto;\n    z-index: 5;\n}\n\n@keyframes pulse {\n    0% { opacity: 0.6; }\n    50% { opacity: 1; }\n    100% { opacity: 0.6; }\n}\n\n.selfieVerificationThumbnail {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    object-fit: cover;\n    cursor: pointer;\n    border: 2px solid #ec4655;\n    transition: all 0.2s ease;\n}\n\n.selfieVerificationThumbnail:hover {\n    border-color: #50b3c5;\n    transform: scale(1.05);\n}\n\n.selfieVerificationLabel {\n    font-size: 12px;\n    font-family: 'Gilroy-Medium';\n    color: #484848;\n    margin-top: 5px;\n    text-align: center;\n    background: rgba(255, 255, 255, 0.9);\n    padding: 2px 6px;\n    border-radius: 8px;\n}\n\n.noSelfieIndicator {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-color: #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px dashed #ccc;\n    cursor: default;\n}\n\n.noSelfieText {\n    font-size: 10px;\n    font-family: 'Gilroy-Medium';\n    color: #999;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
